import React from "react";

import { ReactComponent as MemoIcon } from "../../assets/memo-emoji.svg";

import "./TechnicalPosts.scss";

const TechnicalPosts = () => {
  return (
    <div className="technical-posts">
      <p>
        Bytes of Insight <MemoIcon className="svg-title-icon" />
      </p>
      <div className="content">
        <ul>
          <li>
            <span>Jan 29, 2023: </span>
            <a href="https://medium.com/@swapnil.shah1996/video-streaming-using-hls-protocol-ca76e4fcc31f">
              Video Streaming using HLS protocol
            </a>
          </li>
          <li>
            <span>Mar 28, 2020: </span>
            <a href="https://medium.com/@swapnil.shah1996/designing-a-multi-platform-virtual-agent-370ca3bf42a8">
              Designing a multi platform virtual agent
            </a>
          </li>
          <li>
            <span>Oct 17, 2019: </span>
            <a href="https://medium.com/@swapnil.shah1996/make-free-calls-using-sip-client-f38b6fbf0f40">
              Make free calls using SIP Client
            </a>
          </li>
          <li>
            <span>Oct 14, 2019: </span>
            <a href="https://medium.com/@swapnil.shah1996/update-dialogflow-entities-in-real-time-using-firestore-2c6f2798c1fc">
              Update Dialogflow Entities In Real Time Using Firestore
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TechnicalPosts;
